"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubCommentConnuConsultimTrads = void 0;
exports.ESubCommentConnuConsultimTrads = {
    autre: "Autre",
    connseillerFinancier: "Conseiller Financier ou Gestion de patrimoine",
    email: "Email",
    internet: "Internet",
    presse: "Article de presse",
    publicitePresse: "Publicité presse",
    recommandation: "Recommandation (ami, famille, collègue)",
};
